import {PageCard} from '../../../../layout/page-card/page-card';
import {ShortCatalogType} from '../../../../provider/catalogs/catalogs-type';

import {AccountLinkingVk} from './account-linking-vk';

type PropsType = {
    catalogInfo: ShortCatalogType;
};

export function AccountLinkingVkCard(props: PropsType): JSX.Element {
    const {catalogInfo} = props;

    return (
        <PageCard title={catalogInfo.name}>
            <AccountLinkingVk catalogInfo={catalogInfo} />
        </PageCard>
    );
}
